import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sanitation-reports--table-sections"
export default class extends Controller {
  static targets = ["section", "content", "toggleButton", "expandIcon", "collapseIcon"]

  connect() {
    this.sectionTargets.forEach((section) => {
      this.#syncSection(section, this.#sectionExpanded(section))
    })
  }

  toggle(event) {
    event.preventDefault()

    const section = this.#sectionForButton(event.currentTarget)
    if (!section) return

    this.#syncSection(section, !this.#sectionExpanded(section))
  }

  expandAll(event) {
    event?.preventDefault()

    this.sectionTargets.forEach((section) => {
      this.#syncSection(section, true)
    })
  }

  collapseAll(event) {
    event?.preventDefault()

    this.sectionTargets.forEach((section) => {
      this.#syncSection(section, false)
    })
  }

  #sectionForButton(button) {
    return button.closest("[data-sanitation-reports--table-sections-target~='section']")
  }

  #sectionExpanded(section) {
    const content = this.#targetWithin(section, "content")
    return content ? !content.classList.contains("hidden") : true
  }

  #syncSection(section, expanded) {
    const content = this.#targetWithin(section, "content")
    if (content) content.classList.toggle("hidden", !expanded)

    const button = this.#targetWithin(section, "toggleButton")
    if (button) {
      button.setAttribute("aria-expanded", expanded ? "true" : "false")
      this.#syncButtonLabel(button, expanded)
      this.#syncButtonIcons(button, expanded)
    }
  }

  #syncButtonLabel(button, expanded) {
    const label = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel
    if (!label) return

    button.setAttribute("aria-label", label)
    button.title = label
  }

  #syncButtonIcons(button, expanded) {
    const expandIcon = this.#targetWithin(button, "expandIcon")
    const collapseIcon = this.#targetWithin(button, "collapseIcon")

    if (expandIcon) expandIcon.classList.toggle("hidden", expanded)
    if (collapseIcon) collapseIcon.classList.toggle("hidden", !expanded)
  }

  #targetWithin(element, targetName) {
    return element.querySelector(`[data-sanitation-reports--table-sections-target~='${targetName}']`)
  }
}
